<template>
  <v-card
    tile
    outlined
    @click="toMemoryDetailPage();">
    <v-img
      :lazy-src="placeholder"
      :src="memory.pictureUrl">
      <template v-slot:placeholder>
        <v-layout
          fill-height
          align-center
          justify-center
          class="ma-2">
          <v-progress-circular
            indeterminate
            color="grey darken-1" />
        </v-layout>
      </template>
    </v-img>
    <v-container
      fluid
      class="py-3">
      <v-row justify="start">
        <v-col class="pa-0 mb-3 ml-3 text-left">
          <v-chip
            :color="region.color"
            dark
            label
            small>
            <strong>{{ region.name }}</strong>
          </v-chip>
        </v-col>
      </v-row>

      <v-row justify="start">
        <v-col
          cols="2"
          class="pa-0">
          <v-icon class="mx-2">
            mdi-calendar-month
          </v-icon>
        </v-col>
        <v-col
          cols="9"
          class="pa-0 ml-2 text-left">
          <div>{{ memory.registeredDate }}</div>
        </v-col>
      </v-row>
      <v-row
        justify="start"
        class="mt-1">
        <v-col
          cols="2"
          class="pa-0">
          <v-icon class="mx-2">
            mdi-map-marker-radius
          </v-icon>
        </v-col>
        <v-col
          cols="9"
          class="pa-0 ml-2">
          <div class="text-truncate text-left">
            {{ memory.place }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import prefecture from '../../data/prefecture';
import region from '../../data/region';

import ga from '../../libs/ga';

export default {
  props: {
    memory: {
      type: Object,
      require: true,
      default: () => {
        return {
          pictureUrl: process.env.VUE_APP_NO_IMAGE,
          registeredDate: '',
          place: '',
        };
      },
    },
  },
  data() {
    return {
      placeholder: process.env.VUE_APP_PLACEHOLDER_IMAGE,
      region: {
        name: '',
        color: '',
      },
    };
  },
  created: function() {
    this.memory.pictureUrl = this.memory.pictureUrl ? this.memory.pictureUrl : process.env.VUE_APP_NO_IMAGE;
    this.region.name = prefecture[this.memory.prefecture];
    this.region.color = region.getRegion(this.memory.prefecture).color;
  },
  methods: {
    toMemoryDetailPage: function() {
      ga.memory.moveHistory(this.$ga);

      this.$store.commit('changeTransitionMode', 'fade');
      this.$router.push(`/memory/${this.memory.prefecture}/${this.memory.id}`);
    },
  },
};
</script>
